import { Box, Container, Grid, Typography } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { SectionHeading, Icon } from '@/components/common'
import { whyLeruContent } from '@/data/content'
import { SECTION_IDS } from '@/utils/constants'

/**
 * Why Leru Systems Section Component
 * Explains why to choose Leru Systems
 */
export const WhyLeruSection = () => {
  return (
    <Box
      component="section"
      id={SECTION_IDS.WHY_US}
      sx={{
        py: { xs: 8, md: 10 },
        bgcolor: 'grey.100',
      }}
    >
      <Container maxWidth="lg">
        <SectionHeading align="center" underline>
          {whyLeruContent.heading}
        </SectionHeading>

        <Grid container spacing={{ xs: 3, md: 4 }}>
          {whyLeruContent.differentiators.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Box
                sx={{
                  display: 'flex',
                  gap: 2,
                  p: 3,
                  bgcolor: 'white',
                  borderRadius: 2,
                  height: '100%',
                  border: '1px solid',
                  borderColor: 'grey.200',
                }}
              >
                <Box
                  sx={{
                    flexShrink: 0,
                    pt: 0.5,
                  }}
                >
                  <Icon
                    icon={CheckCircleIcon}
                    size="medium"
                    color="primary"
                    sx={{
                      fontSize: '2rem',
                    }}
                  />
                </Box>
                <Box>
                  <Typography
                    variant="h6"
                    component="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 1,
                      fontSize: '1.125rem',
                    }}
                  >
                    {item.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                      lineHeight: 1.6,
                    }}
                  >
                    {item.description}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  )
}
